// PROMPT 13B — Staff Document Center shared constants + helpers.

export const CATEGORY_LABELS = {
  intake: "Intake", photos: "Photos", poa_contact_notes: "POA / contact notes",
  quotes: "Quotes", contracts: "Contracts", roadmap: "Roadmap",
  partner_proposals: "Partner proposals", property_documents: "Property documents",
  care_notes: "Care notes", meeting_documents: "Meeting documents",
  legal_professional_review: "Legal / professional review", signing_documents: "Signing documents",
  facility_documents: "Facility documents", vendor_documents: "Vendor documents",
  internal_documents: "Internal documents", other: "Other",
};

// status -> {label, hex}
export const STATUS_META = {
  draft: { label: "Draft", hex: "#6B7280" },
  requested: { label: "Requested", hex: "#B7791F" },
  uploaded: { label: "Uploaded", hex: "#2C6480" },
  waiting_for_review: { label: "Waiting for review", hex: "#B7791F" },
  under_review: { label: "Under review", hex: "#2C6480" },
  needs_changes: { label: "Needs changes", hex: "#9C1E22" },
  needs_clarification: { label: "Needs clarification", hex: "#9C1E22" },
  shared: { label: "Shared", hex: "#2F7D5A" },
  approved: { label: "Approved", hex: "#2F7D5A" },
  ready_for_signing: { label: "Ready for signing", hex: "#7C3AED" },
  signing_pending: { label: "Signing pending", hex: "#7C3AED" },
  signed: { label: "Signed", hex: "#2F7D5A" },
  rejected: { label: "Rejected", hex: "#9C1E22" },
  archived: { label: "Archived", hex: "#94A3B8" },
};

export const AUDIENCE_LABELS = {
  client: "Client", family_member: "Family member", temporary_guest: "Temporary guest",
  professional_guest: "Professional", partner_vendor: "External portal",
  meeting_participant: "Meeting participant",
};

export const PRIORITY_META = {
  low: { label: "Low", hex: "#94A3B8" }, normal: { label: "Normal", hex: "#6B7280" },
  high: { label: "High", hex: "#B7791F" }, urgent: { label: "Urgent", hex: "#9C1E22" },
};

export const SECTION_META = {
  needs_review: { label: "Needs Review", icon: "ClipboardCheck", hex: "#B7791F" },
  requested: { label: "Requested", icon: "Send", hex: "#2C6480" },
  signing_pending: { label: "Signing Pending", icon: "PenLine", hex: "#7C3AED" },
  recently_uploaded: { label: "Recently Uploaded", icon: "UploadCloud", hex: "#2F7D5A" },
  shared_externally: { label: "Shared Externally", icon: "Share2", hex: "#1C4358" },
  professional_review: { label: "Professional Review", icon: "Scale", hex: "#4B5563" },
  archived: { label: "Archived", icon: "Archive", hex: "#94A3B8" },
};

export const LINK_LABELS = {
  client: "Client", external_account: "External account", lead: "Lead", referral: "Referral",
  meeting: "Meeting", opportunity: "Opportunity", partner: "Partner", relationship: "Relationship",
};

export const catLabel = (v) => CATEGORY_LABELS[v] || v || "—";
export const statusMeta = (v) => STATUS_META[v] || { label: v || "—", hex: "#6B7280" };

export const fmtDate = (v) => {
  if (!v) return "—";
  try {
    return new Date(v).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
  } catch { return v; }
};
export const fmtDateTime = (v) => {
  if (!v) return "—";
  try {
    return new Date(v).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
  } catch { return v; }
};

export const hexA = (hex, a) => {
  const h = hex.replace("#", "");
  const n = parseInt(h.length === 3 ? h.split("").map((c) => c + c).join("") : h, 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${a})`;
};

export const isOverdue = (d) =>
  d?.due_date && !d?.uploaded && new Date(d.due_date) < new Date(new Date().toISOString().slice(0, 10));
